import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../../components/Button/Button'
import InstructionList from '../../components/InstructionList/InstructionList'
import Spinner from '../../components/Spinner/Spinner'
import { isInPhoneOrTablet } from '../../utils/common/isInPhoneOrTablet'
import InternetIssue from '../../components/InternetIssue/InternetIssue'
import PopUpWrapper from '../../components/PopUpWrapper/PopUpWrapper'
import offline from '../../../src/assets/offline.svg'

import marksIcon from '../../assets/marks.svg'
import questionsIcon from '../../assets/questions.svg'
import durationIcon from '../../assets/duration.svg'
import { EVENT_NAMES } from 'constants/eventNames'
import { trackEvent } from 'utils/analyticsService'
import { ANALYTICS_KEYS } from 'constants/analytics-keys'

function InstructionsUI({
    showStartPreviewBtn,
    isSecure,
    buttonText,
    instructions,
    setRedirectToTestPanel,
    giveTest,
    connection,
}) {
    const { t } = useTranslation()

    return (
        <main className="instructions">
            {connection === 'offline' ? (
                <InternetIssue
                    message={t(
                        'There seems to be a problem with your Internet Network Connection',
                    )}
                />
            ) : null}
            {connection === 'online' ? (
                <PopUpWrapper
                    isToast={true}
                    toastType={'success'}
                    width={'281px'}
                    height={'81px'}
                    top={'auto'}
                    right={'auto'}
                    closeButtonBackground={'#000'}
                >
                    <div className="status-container">
                        <img src={offline} alt="offline" />
                        <div>
                            <div className="status-text">
                                <span className="status-type">
                                    {t('Connected!')}
                                </span>
                                <span className="status-message">
                                    {t('You are back online')}
                                </span>
                            </div>
                        </div>
                    </div>
                </PopUpWrapper>
            ) : null}
            <div className="instruction-container">
                <div className="instruction-header">
                    <div className="instruction-header-title-section">
                        <div role="heading" className="instruction-header-title">
                            {t('General Instructions')}
                        </div>
                        <div role="heading" className="instruction-header-subtitle">
                            {t('Please read the instructions carefully')}
                        </div>
                    </div>
                    <section role="section" className="instruction-test-contraints">
                        <dl role="list" className="constraints-data">
                            <img
                                className="constraints-icon"
                                src={durationIcon}
                                alt="constraints"
                            />
                            <dt role="term" className="constraints-text">
                                {t('Duration')}
                            </dt>
                            <dd role="definition" className="constraints-value">
                                {instructions.testData.allowedDuration} {t('mins')}
                            </dd>
                        </dl>
                        <dl role="list" className="constraints-data">
                            <img
                                className="constraints-icon"
                                src={questionsIcon}
                                alt="constraints"
                            />
                            <dt role="term" className="constraints-text">
                                {t('Questions')}
                            </dt>
                            <dd role="definition" className="constraints-value">
                                {instructions.testData.totalQuestion}
                            </dd>
                        </dl>
                        <dl role="list" className="constraints-data">
                            <img
                                className="constraints-icon"
                                src={marksIcon}
                                alt="constraints"
                            />
                            <dt role="term" className="constraints-text">
                                {t('Marks')}
                            </dt>
                            <dd role="definition" className="constraints-value">
                                {instructions.testData.maxMarks}
                            </dd>
                        </dl>
                    </section>
                </div>
                <InstructionList instructions={instructions.testData} />
                {showStartPreviewBtn ? (
                    <Button
                        name="Start Test"
                        classes="btn_class2"
                        onClick={() => {
                            trackEvent(EVENT_NAMES.TESTPLAYER_START_TEST, '', {
                                [ANALYTICS_KEYS.TEST_ID]: instructions?.testData?.id,
                            })
                            setRedirectToTestPanel(true)
                        }}
                    ></Button>
                ) : (
                    <div className="start-button-wrapper">
                        {isSecure === true ? (
                            buttonText ? (
                                <Button
                                    name={buttonText}
                                    classes={
                                        isInPhoneOrTablet() === true
                                            ? 'btn_class1'
                                            : 'btn_class2'
                                    }
                                    onClick={giveTest}
                                />
                            ) : (
                                <Spinner message={'loading'} />
                            )
                        ) : (
                            <p className="p_class">
                                {t('Seems like you are a bot!')}
                            </p>
                        )}
                    </div>
                )}
            </div>
        </main>
    )
}

export default InstructionsUI
